import { render } from "./MasterDataUpdateView.vue?vue&type=template&id=db063074&ts=true"
import script from "./MasterDataUpdateView.vue?vue&type=script&lang=ts"
export * from "./MasterDataUpdateView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__